var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            { staticClass: "title", staticStyle: { "font-size": "26px" } },
            [_vm._v("您好，")]
          ),
          _c(
            "div",
            {
              staticClass: "text",
              staticStyle: { "font-size": "18px", "margin-top": "10px" }
            },
            [_vm._v(" 欢迎使用" + _vm._s(_vm.propName) + " ")]
          ),
          _vm.loginType == "password"
            ? [
                _c("div", { staticClass: "phoneBox" }, [
                  _c("div", { staticClass: "inputBox userName" }, [
                    _c("div", { staticClass: "inputer" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.submitMode.mobile,
                            expression: "submitMode.mobile"
                          }
                        ],
                        attrs: {
                          type: "tel",
                          placeholder: "请输入在物业登记的手机号码"
                        },
                        domProps: { value: _vm.submitMode.mobile },
                        on: {
                          blur: _vm.inputBlur,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.submitMode,
                              "mobile",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "formUnit" }, [
                    _c("div", { staticClass: "inputBox" }, [
                      _c("div", { staticClass: "inputer " }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.submitMode.pwd,
                              expression: "submitMode.pwd"
                            }
                          ],
                          staticClass: "gray",
                          attrs: {
                            type: "password",
                            placeholder: "请输入密码"
                          },
                          domProps: { value: _vm.submitMode.pwd },
                          on: {
                            blur: _vm.inputBlur,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.submitMode,
                                "pwd",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "getCode",
                    staticStyle: { "padding-top": "50px" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: { disabled: _vm.loginBtnIs },
                        on: {
                          click: function($event) {
                            return _vm.handlerLogin()
                          }
                        }
                      },
                      [_vm._v(" 登录 ")]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "12px",
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c("div"),
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#0893ea", "font-size": "14px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.toForgetPwd }
                      },
                      [_vm._v(" 忘记密码 ")]
                    )
                  ]
                ),
                _c("div", { staticClass: "wx-icon" }, [
                  _c("img", {
                    staticStyle: { width: "60px" },
                    attrs: { src: require("../../assets/images/wx.png") },
                    on: { click: _vm.wxLogin }
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: { "font-size": "14px", "margin-top": "10px" }
                    },
                    [_vm._v("微信一键登录")]
                  )
                ])
              ]
            : _c(
                "div",
                {
                  staticClass: "getCode",
                  staticStyle: { padding: "40px 30px 0 30px" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      staticStyle: {
                        "background-color": "#67C23A",
                        height: "60px",
                        "border-radius": "20px"
                      },
                      attrs: { disabled: _vm.loginBtnIs },
                      on: {
                        click: function($event) {
                          return _vm.wxLogin()
                        }
                      }
                    },
                    [_vm._v(" 微信一键登录 ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      staticStyle: {
                        "margin-top": "16px",
                        height: "60px",
                        "border-radius": "20px"
                      },
                      attrs: { disabled: _vm.loginBtnIs },
                      on: {
                        click: function($event) {
                          _vm.loginType = "password"
                        }
                      }
                    },
                    [_vm._v(" 账号密码登录 ")]
                  )
                ]
              )
        ],
        2
      ),
      _c("view-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }